import $ from 'jquery';
class Faqlist {
    constructor(element) {
        $(document).ready(() => this.load());
    }

    load() {
        this.visibleTabs();
        this.toggleDropdown();
    }

    toggleDropdown() {
        const toggler =  document.querySelectorAll('.dropdown_toggle');

        toggler.forEach((item) => {
            item.addEventListener('click', () => {
                item.classList.contains('open') ? item.classList.remove('open') : item.classList.add('open');
            });
        });
    }

    visibleTabs() {

        const tabs = document.querySelectorAll('.twz-element-faq__tabs .head-item');
        const tabContent = document.querySelectorAll('.twz-element-faq__tabs .twz-element-faq__tabs__tab');

        tabs.forEach(tab => {

            tabs[0].classList.add('active');
            tabContent[0].classList.add('active');

            tab.addEventListener('click', (e) => {
                const target = document.querySelector(tab.dataset.tabTarget);

                tabContent.forEach(tabContent => {
                    tabContent.classList.remove('active');
                });
                target.classList.add('active');


                tabs.forEach(tab => {
                    tab.classList.remove('active');
                });
                e.target.classList.add("active");

            })
        })

    };



}

new Faqlist